import createStyles from "@mui/styles/createStyles";

export default () => createStyles({
    button: {
        width: '100%',
    },
});